import 'rc-pagination/dist/rc-pagination.min.css';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getGuessLikes } from '../../actions/recommend';
import ALineCard from '../../components/ALineCard/ALineCard';
import LineCard from '../../components/LineCard/LineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import styles from './GuessLikesMore.module.less';

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);

const selectGuessLikes = createSelector(
  state => state.recommend,
  recommend => recommend.guessLike,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(() => {
  const dispatch = useDispatch();
  const guessLikesData = useSelector(selectGuessLikes);
  const searchRecommend = useSelector(selectSearchRecommend);
  const localSoftsInit = useSelector(selectLocalSoftsInit);
  const logInfoData = useSelector(selectLogInfo);

  const pageSize = 60;
  const [showMoreApps, setShowMoreApps] = useState([]);

  useEffect(() => {
    if (
      !guessLikesData ||
      !guessLikesData.apps ||
      guessLikesData.apps.length === 0 ||
      guessLikesData.limit !== pageSize
    ) {
      dispatch(getGuessLikes({ skip: 0, limit: pageSize }));
    } else {
      const showApps = [];
      guessLikesData.apps.forEach(item => {
        const found = localSoftsInit.find(
          soft => soft.softID === item.softID || soft.SoftID === item.softID,
        );
        if (found === undefined) {
          showApps.push(item);
        }
      });
      setShowMoreApps(showApps);
    }
  }, [dispatch, guessLikesData, localSoftsInit]);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Reco_Guess_More',
        label: '',
        param2: {
          source: 'Reco_Guess_More',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Reco_Guess_More',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.page}>
      <div className={styles.page_container}>
        <div className={styles.recommend_header}>
          <div className={styles.recommend_header_title}>猜你喜欢</div>
        </div>
        {showMoreApps && showMoreApps.length > 0 ? (
          <div className={styles.app_cards}>
            {showMoreApps.map((soft, i) =>
              soft.androidType === '1' ? (
                <React.Fragment key={i}>
                  <ALineCard
                    logInfo={{ source: 'Reco_Guess_More' }}
                    soft={soft}
                    key={i}
                    softIndex={i}
                  />
                  {searchRecommend[soft.packageName] &&
                    searchRecommend[soft.packageName].apps &&
                    searchRecommend[soft.packageName].apps.length > 4 && (
                      <LineCardDReco
                        recommendData={searchRecommend[soft.packageName]}
                        logInfo={{
                          source: `Reco_Guess_More|| ||DReco||${soft.packageName}`,
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                        }}
                      />
                    )}
                </React.Fragment>
              ) : (
                <React.Fragment key={i}>
                  <LineCard logInfo={{ source: 'Reco_Guess_More' }} soft={soft} softIndex={i} />
                  {searchRecommend[soft.softID] &&
                    searchRecommend[soft.softID].apps &&
                    searchRecommend[soft.softID].apps.length > 4 && (
                      <LineCardDReco
                        recommendData={searchRecommend[soft.softID]}
                        logInfo={{
                          source: `Reco_Guess_More|| ||DReco||${soft.softID}`,
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                        }}
                      />
                    )}
                </React.Fragment>
              ),
            )}
          </div>
        ) : (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
});
